module.exports = "/images/img_04.png?9fe3b1c71927c539fcacdf2a830d19c2";